module.exports = __webpack_public_path__ + "img/SweepTips.7ff2ad6b.png";